import script from "./CustomerLeadsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerLeadsTable.vue?vue&type=script&setup=true&lang=js"

import "./CustomerLeadsTable.vue?vue&type=style&index=0&id=6993465d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6993465d"]])

export default __exports__